import { withInstall } from '@code-monkey-ui/utils'

import ColorPicker from './src/color-picker.vue'

export const ElColorPicker = withInstall(ColorPicker)
export default ElColorPicker

export * from './src/color-picker'
